module.exports = __webpack_public_path__ + "img/logo.3fd48169.png";